import { extractEnvelopeQuotaFromPayload } from './subscription';

let syncHandler = null;

/** Register once at app startup (see index.js) to avoid api ↔ store circular imports. */
export function registerEnvelopeQuotaSyncHandler(handler) {
  syncHandler = handler;
}

/** Sync quota from any API response body that includes envelope_quota. */
export function syncEnvelopeQuotaFromApiResponse(data) {
  const quota = extractEnvelopeQuotaFromPayload(data);
  if (quota && syncHandler) {
    syncHandler(quota);
  }
}
